// extracted by mini-css-extract-plugin
export default {"group-title":"style_group-title__+XYHU"};